import { supabase } from './supabase';

/**
 * Devuelve el plan actual del usuario logueado (lee company_profiles.plan).
 * Si algo falla, devuelve null (defensivo: tratamos como "sin plan").
 */
export async function getUserPlan(): Promise<string | null> {
  try {
    const {
      data: { user },
    } = await supabase.auth.getUser();
    if (!user) return null;

    const { data: profile } = await supabase
      .from('profiles')
      .select('id_company')
      .eq('id', user.id)
      .single();
    if (!(profile as any)?.id_company) return null;

    const { data: company } = await supabase
      .from('company_profiles')
      .select('plan')
      .eq('id_company', (profile as any).id_company)
      .single();
    return ((company as any)?.plan as string | null) ?? null;
  } catch {
    return null;
  }
}

/**
 * Indica si el plan permite crear marcas adicionales (multi-marca).
 * Hoy: cualquier plan distinto de 'gratis' puede hacerlo. Si no hay plan
 * (null o desconocido), tratamos como bloqueado por defecto.
 */
export function planAllowsMultiBrand(plan: string | null | undefined): boolean {
  if (!plan) return false;
  const normalized = plan.toString().trim().toLowerCase();
  return normalized !== 'gratis';
}
